<div class="form-designer">
  <nz-layout>
    <!-- 左侧控件 -->
    <nz-sider [nzWidth]="260">
      <div class="fields-list">
        <div
          *ngFor="let componentGroup of componentGroups; let listIndex = index"
          id="components_{{ listIndex }}"
          dndDropZone
          [dndAllowExternal]="true"
        >
          <div class="field-title">{{ componentGroup.label }}</div>

          <div
            *ngFor="let component of componentGroup.components; let index"
            class="ghost field-label"
            [dndDraggable]="component"
            dndEffectAllowed="copy"
          >
            <a>
              <i class="modules" [ngClass]="component.icon"></i>
              <span>{{ component.label }}</span>
            </a>
          </div>
        </div>
      </div>
    </nz-sider>

    <!-- 中间内容 -->
    <nz-layout class="widget-container">
      <!-- 顶部工具条 -->
      <nz-header class="widget-container-header">
        <div *ngIf="undoRedo">
          <a nz-button nzType="link" [disabled]="history.index === 0" (click)="handleUndo()">撤销</a>
          <a nz-button nzType="link" [disabled]="history.index === history.steps.length - 1" (click)="handleUndo()">重做</a>
        </div>
        <div style="display: flex; align-items: center">
          <a *ngIf="toolbar.includes('import')" nz-button nzType="link" (click)="handleImportJson()">导入JSON</a>
          <a *ngIf="toolbar.includes('generate')" nz-button nzType="link" (click)="handleGenerateJson()">生成JOSN</a>
          <a *ngIf="toolbar.includes('preview')" nz-button nzType="link" (click)="handlePreview()">预览</a>
          <a *ngIf="toolbar.includes('clear')" nz-button nzType="link" (click)="handleClear()">清空</a>
        </div>
      </nz-header>
      <!-- 中间画板 -->
      <nz-content>
        <!-- 渲染 -->
        <div d-widget-form-render [component]="rootComponent" [(selectComponent)]="selectComponent" class="widget-form-container"> </div>
      </nz-content>
    </nz-layout>

    <!-- 右侧配置 -->
    <nz-sider class="right-sider" [nzWidth]="320">
      <nz-tabset>
        <nz-tab nzTitle="组件属性" nzActive>
          <app-widget-config class="p-20" [data]="selectComponent" [defaultValues]="defaultValues"></app-widget-config>
        </nz-tab>
        <nz-tab nzTitle="表单属性"><app-form-config class="p-20" [data]="rootComponent"></app-form-config></nz-tab>
      </nz-tabset>
    </nz-sider>
  </nz-layout>

  <!-- 导入json -->
  <nz-drawer
    [nzClosable]="true"
    [nzVisible]="importJsonVisible"
    [nzWidth]="'100%'"
    [nzBodyStyle]="{ overflow: 'auto' }"
    nzPlacement="right"
    nzTitle="导入JSON"
    (nzOnClose)="closeImportJson()"
  >
    <ng-container *nzDrawerContent>
      <textarea *ngIf="importJsonVisible" nz-input [(ngModel)]="importJson" [nzAutosize]="{ minRows: 10, maxRows: 50 }"></textarea>
    </ng-container>
  </nz-drawer>

  <!-- 预览json -->
  <nz-drawer
    [nzClosable]="true"
    [nzVisible]="previewJsonVisible"
    [nzWidth]="'100%'"
    [nzBodyStyle]="{ overflow: 'auto' }"
    nzPlacement="right"
    nzTitle="预览JSON"
    (nzOnClose)="closePreviewJson()"
  >
    <ng-container *nzDrawerContent>
      <textarea *ngIf="previewJson" nz-input [ngModel]="previewJson" readonly [nzAutosize]="{ minRows: 10, maxRows: 50 }"></textarea>
    </ng-container>
  </nz-drawer>

  <!-- 预览表单 -->
  <nz-drawer
    [nzClosable]="true"
    [nzVisible]="previewFormVisible"
    [nzWidth]="'100%'"
    [nzBodyStyle]="{ overflow: 'auto' }"
    nzPlacement="right"
    nzTitle="预览表单"
    (nzOnClose)="closePreviewForm()"
  >
    <ng-container *nzDrawerContent>
      <r-widget-form [previewJson]="previewJson" (submitForm)="sfSubmit($event)" (resetForm)="sfReset($event)"></r-widget-form>
    </ng-container>
  </nz-drawer>
</div>
